import React from 'react'
import './Footer.css'
import Image from './images/footer.jpg'

const Footer = () => {
    return (
        <div>

            <footer class="footer_section">
                <div class="container-fluid">
                    <div class="f-items">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 item">
                                <div class="f-item">
                                    <img src={Image} alt="Logo" className='img-fluid' />
                                    <p>
                                        Hamo Tech offers top-notch training in Java, AWS, MERN Stack, and more. Our
                                        goal is to provide students with the skills and expertise to excel in the tech industry.
                                    </p>
                                    <p class="text-italic">
                                        Please write your email and get our amazing updates, news and support
                                    </p>
                                    <div class="subscribe">
                                        <form action="#">
                                            <div class="input-group stylish-input-group">
                                                <input type="email" placeholder="Enter your e-mail here" class="form-control"
                                                    name="email" />
                                                <button type="submit">
                                                    <i class="ri-telegram-2-fill"></i>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-6 item">
                                <div class="f-item link">
                                    <h4>Links</h4>
                                    <ul>
                                        <li>
                                            <a href="#">Courses</a>
                                        </li>
                                        <li>
                                            <a href="#">Event</a>
                                        </li>
                                        <li>
                                            <a href="#">Gallery</a>
                                        </li>
                                        <li>
                                            <a href="#">Faqs</a>
                                        </li>
                                        <li>
                                            <a href="#">Teachers</a>
                                        </li>
                                        <li>
                                            <a href="#">Contact</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-6 item">
                                <div class="f-item link">
                                    <h4>Support</h4>
                                    <ul>
                                        <li>
                                            <a href="#">Documentation</a>
                                        </li>
                                        <li>
                                            <a href="#">Forums</a>
                                        </li>
                                        <li>
                                            <a href="#">Language Packs</a>
                                        </li>
                                        <li>
                                            <a href="#">Release Status</a>
                                        </li>
                                        <li>
                                            <a href="#">LearnPress</a>
                                        </li>
                                        <li>
                                            <a href="#">Feedback</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 item">
                                <div class="f-item address">
                                    <h4>Address</h4>
                                    <ul>
                                        <li>
                                            <i class="ri-mail-ai-line"></i>
                                            <p>Email <span><a
                                                href="mailto:#">Hamotechsd@gmail.com</a></span>
                                            </p>
                                        </li>
                                        <li>
                                            <i class="ri-building-2-line"></i>
                                            <p>Office 1<span>Singapore: 10 Jalan Besar, #08-06, SIM LIM Tower - 208787</span></p>
                                        </li>
                                        <li>
                                            <i class="ri-phone-line"></i>
                                            <p>Contact Singapore<span><a
                                                href="tel:+6589109120">+(65) 89109120</a></span>
                                            </p>
                                        </li>
                                        <li>
                                            <i class="ri-building-2-line"></i>
                                            <p>Office 2<span>India: No 2/84 sivaprakasam nagar, Ambattur Redhills Road, Surapet , Chennai - 600066.</span></p>
                                        </li>
                                        <li>
                                            <i class="ri-phone-line"></i>
                                            <p>Contact India<span><a
                                                href="tel:+918688964015">+(91) 8688964015</a></span>
                                            </p>
                                        </li>

                                    </ul>
                                    <div class="opening-info">
                                        <h5 style={{ color: "#e65753" }}>Opening Days</h5>
                                        <ul>
                                            <li> <span> Monday - Saturday</span>
                                                {/* <div class="float-end"> 6.00 am - 10.00 pm </div> */}
                                            </li>
                                            {/* <li> <span> Wednes - Thurs :</span>
                                                <div class="float-end"> 8.00 am - 6.00 pm </div>
                                            </li>
                                            <li> <span> Sun : </span>
                                                <div class="float-end closed"> Closed </div>
                                            </li> */}
                                        </ul>
                                        <h5 style={{ color: "#e65753" }}>Closing Day</h5>
                                        <ul>
                                            <li> <span> Sunday </span>
                                                {/* <div class="float-end"> 6.00 am - 10.00 pm </div> */}
                                            </li>
                                            {/* <li> <span> Wednes - Thurs :</span>
                                                <div class="float-end"> 8.00 am - 6.00 pm </div>
                                            </li>
                                            <li> <span> Sun : </span>
                                                <div class="float-end closed"> Closed </div>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="footer-bottom">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <p>&copy; Copyright 2024. All Rights Reserved by <a href="#" style={{ color: "#e65753" }}>HAMO TECH PTE LTD</a></p>
                            </div>
                            <div class="col-lg-6 text-end link">
                                <ul>
                                    <li>
                                        <a href="#">Terms of user</a>
                                    </li>
                                    <li>
                                        <a href="#">License</a>
                                    </li>
                                    <li>
                                        <a href="#">Support</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>

        </div>
    )
}

export default Footer
